// Track mouse position and update CSS variables
function updateTooltipPosition(e) {
    document.documentElement.style.setProperty('--mouse-x', e.clientX);
    document.documentElement.style.setProperty('--mouse-y', e.clientY);
}

export function initTooltips() {
    // Initial check for truncated elements
    checkTruncation();

    // Recheck on window resize
    window.addEventListener('resize', checkTruncation);

    // Recheck when new content is loaded
    const observer = new MutationObserver(checkTruncation);
    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
}

function checkTruncation() {
    const titles = document.querySelectorAll('.meeting-title');
    titles.forEach((title) => {
        const isTruncated = title.scrollWidth > title.clientWidth;
        if (isTruncated) {
            const tooltipText = title.textContent;
            title.setAttribute('title', tooltipText);
            title.removeAttribute('data-tooltip');
        } else {
            title.removeAttribute('title');
            title.removeAttribute('data-tooltip');
        }
    });
}
